<template>
  <div>
    <!--标题-->
    <div class="detailsTitle" style="padding-top: 10px;">
      <h4>结算明细字段</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
               <el-form-item label="显示名称:" prop="billName">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.billName"></el-input>
              </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-button type="primary" @click="searchClick" btnCode='000P00OB00C' v-if="btnFlg[0]">查询</el-button>
        <el-button type="primary" @click="resetClick" btnCode='000P00OB00D' v-if="btnFlg[1]">重置</el-button>
        <el-button type="primary" @click="addBtnClick"  btnCode='000P00OB00E' v-if="btnFlg[2]">新增</el-button>
        <el-button type="primary" @click="changeBtnClick" btnCode='000P00OB00F' v-if="btnFlg[3]">修改</el-button>
        <el-button type="primary" @click="delClick" btnCode='000P00OB00G' v-if="btnFlg[4]">删除</el-button>
        <el-button type="primary" @click="backTo"  >返回上一级</el-button>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="91%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click="dianjixuanzhong"
        @current-change="handleTabCurrentChange"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="billName"    label="显示名称"  align="center" ></el-table-column>
        <el-table-column prop="billStandard"   label="字段名称" align="center" ></el-table-column>
        <el-table-column prop="orderBy" label="顺序"  align="center" ></el-table-column>
        <el-table-column prop="createUser" label="创建人" align="center" ></el-table-column>
        <el-table-column prop="createTime"   label="创建时间" align="center" :formatter="dateFormat"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNum"
        :page-sizes="[1,10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="addMark"
    width="900px"
    center>
      <span>
         <el-form
          :model="addFrom"
          ref="addFrom"
          :rules="rules"
          :validate-on-rule-change = "false"
          class="demo-form-inline"
          label-width="140px" size="mini">
        <div class="addinpBox" >
          <el-form-item  label="显示名称"
            prop='showName'
            style="margin-top:20px;">
            <el-input v-model="addFrom.showName" maxlength="20" style="width:210px;" :validate-event = "false"></el-input>
          </el-form-item>
          <el-form-item  label="字段名称"
            prop='fieldName'
            style="margin-top:20px;">
            <el-input v-model="addFrom.fieldName" maxlength="20" onkeyup="var reg = /^[a-zA-Z]+$/;if(!reg.test(this.value)) this.value='';" style="width:210px;" :validate-event = "false" :disabled="fieldNameDisabled"></el-input>
          </el-form-item>
          <el-form-item  label="字段顺序"
            prop='fieldOrder'
            style="margin-top:20px;">
            <el-input v-model="addFrom.fieldOrder" style="width:210px;" maxlength="3" v-number-input.float="0" :validate-event = "false"></el-input>
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'   @click="addSubmit('addFrom')" :loading='addLoading' v-if="addBtnShow">保存</el-button>
        <el-button type="primary" size='mini'   @click="changeSubmit('addFrom')" :loading='changeLoading' v-if="changeBtnShow">修改</el-button>
        <el-button @click="addSpuClose('addFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  feelistDetailAdd, // 新增
  feelistDetailList, // 列表
  // seeGroupType, // 获取下拉框数据
  feelistDetailUpdate, // 修改
  feelistDetailDelete, // 删除
  feelistDetailCheckSkuExist // 判断能否删除
} from '@/api/platform-settlement'
import DonMessage from '@/utils/message'
// eslint-disable-next-line no-unused-vars
import { getBtn } from '@/utils/getButton'
export default {
  // components:{},
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['000P00OB00C', '000P00OB00D', '000P00OB00E', '000P00OB00F', '000P00OB00G'],
      feeId: '',
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        feeId: localStorage.getItem('feeId'),
        pageNo: 1,
        pageSize: 10
      },
      statusOptions: [{
        value: '1',
        label: '启用'
      }, {
        value: '0',
        label: '停用'
      }],
      value: '',
      tableList: [],
      tableHeardArr: [],
      attrName: '', // 表头信息
      // 新增
      addLoading: false,
      rules: {
        showName: [
          { required: true, message: '显示名称不能为空！', trigger: 'blur' }
        ],
        fieldName: [
          { required: true, message: '字段名称不能为空！', trigger: 'blur' }
        ],
        fieldOrder: [
          { required: true, message: '字段顺序不能为空！', trigger: 'blur' }
        ]
      },
      fieldNameDisabled: false, // 字段名修改禁用
      bianMaOptions: [],
      dataTypeOptions: [],
      jiLiangDanWeiOptions: [],
      selectOptions: [],
      selectData: '',
      addBtnShow: false,
      changeBtnShow: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      addMark: false, // 新增弹框
      changeLoading: false,
      addFrom: {
        showName: '',
        fieldName: '',
        fieldOrder: '',
        formDataArr: [{
          attrName: '',
          ext3: '',
          isnotFlg: ''
        }]
      },
      xuanzhongArr: [],
      delBtnShow: true,
      spuName: '',
      changeId: ''
    }
  },
  created () {
    this.getSeatchData(this.searchFrom)
    this.feeId = localStorage.getItem('feeId')
    // this.spuName = localStorage.getItem('spuName')
    this.btnFlg = getBtn(this.btnIdArr, '/smpAttribute')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 225) + 'px'
  },
  methods: {
    // 点击主表选中需要修改的行
    dianjixuanzhong (row, column, event) {
      this.xuanzhongArr = row
      this.currentXQ = 1
      this.$refs.tableRef.toggleRowSelection(row)
    },
    // 查询接口
    getSeatchData () {
      feelistDetailList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    resetClick () {
      this.searchFrom = {
        feeId: this.feeId,
        pageNo: 1,
        pageSize: 10
      }
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNum = val
      this.getSeatchData(this.searchFrom)
    },
    // 点击修改按钮
    changeBtnClick (row) {
      // let selectData = this.$refs.tableRef.selection
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else {
        this.addMark = true
        this.title = '修改字段'
        this.addBtnShow = false
        this.changeBtnShow = true
        this.fieldNameDisabled = true
        this.addFrom.showName = this.xuanzhongArr.billName
        this.addFrom.fieldName = this.xuanzhongArr.billStandard
        this.addFrom.fieldOrder = this.xuanzhongArr.orderBy
        this.changeId = this.xuanzhongArr.id
      }
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 点击删除
    delClick () {
      // console.log(this.xuanzhongArr,'222')
      // eslint-disable-next-line no-unused-vars
      let selectData = this.$refs.tableRef.selection
      // console.log(selectData.length,'222')
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else {
        feelistDetailCheckSkuExist({
          feeId: this.feeId
        }).then(res => {
          if (res > '0') {
            this.$message.error('此条数据不能删除！')
          } else {
            this.$confirm('是否确定删除？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                feelistDetailDelete({
                  id: this.xuanzhongArr.id, // id
                  feeId: this.feeId
                })
                  .then(res => {
                    DonMessage.success('操作成功!')
                    this.getSeatchData(this.searchFrom)
                  })
                  .catch(err => {
                    DonMessage.error(err.message)
                  })
              })
          }
        }).catch(err => {
          DonMessage.error(err.message)
        })
          .catch(() => {
            console.log('222')
          })
      }
    },
    // 点击新建按钮
    addBtnClick () {
      this.addMark = true
      this.addBtnShow = true
      this.changeBtnShow = false
      this.fieldNameDisabled = false
      this.title = '新增字段'
      this.addFrom = {}
    },
    // 点击新增确定
    addSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addLoading = true
          feelistDetailAdd({
            feeId: this.feeId,
            billName: this.addFrom.showName, // 显示名称
            billStandard: this.addFrom.fieldName, // 字段名称
            orderBy: this.addFrom.fieldOrder // 顺序
          }).then(res => {
            this.$message.success('添加成功！')
            this.addLoading = false
            this.getSeatchData(this.searchFrom)
            this.addMark = false
          }).catch(err => {
            this.addLoading = false
            this.$message.error(err.message)
          })
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 修改确定
    changeSubmit (formName) {
      // console.log(this.addFrom.formDataArr)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changeLoading = true
          feelistDetailUpdate({
            id: this.changeId,
            feeId: this.feeId,
            billName: this.addFrom.showName, // 显示名称
            billStandard: this.addFrom.fieldName, // 字段名称
            orderBy: this.addFrom.fieldOrder // 顺序
          }).then(res => {
            this.$message.success('修改成功！')
            this.changeLoading = false
            this.getSeatchData(this.searchFrom)
            this.addMark = false
          }).catch(err => {
            this.changeLoading = false
            this.$message.error(err.message)
          })
          // console.log(name)
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 取消
    addSpuClose (formName) {
      this.$refs[formName].resetFields()
      this.addMark = false
      // console.log('2222')
    },
    // 返回上一级
    backTo () {
      this.$router.push('/smpAttribute')
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>
<style scoped lang='less'>
.el-table{
overflow:visible !important;
}
.searchBox{
  margin-left: 10px;
}
.inpBox{
  margin: 0 0 0 -30px;
}

 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBtnBox{
  margin-top: 5px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
</style>
